import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function InventoryPrint() {
  const [report, setReport] = useState(null);

  useEffect(() => {
    api.get("/reports/inventory").then(({ data }) => {
      setReport(data);
      setTimeout(() => window.print(), 400);
    });
  }, []);

  if (!report) return <div style={{ padding: 40 }}>Carregando…</div>;

  const now = new Date().toLocaleString("pt-BR");

  return (
    <div style={{ fontFamily: "Helvetica, Arial, sans-serif", padding: "30px 40px", maxWidth: 900, margin: "0 auto", color: "#000" }}>
      <style>{`
        @media print {
          @page { margin: 15mm; }
          .no-print { display: none !important; }
          body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        }
        table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
        th, td { border: 1px solid #000; padding: 6px 10px; text-align: left; font-size: 12px; }
        th { background: #000; color: #fff; text-transform: uppercase; letter-spacing: 1px; font-size: 10px; }
        .total-row td { background: #f0f0f0; font-weight: bold; }
      `}</style>
      <div style={{ borderBottom: "3px solid #000", paddingBottom: 12, marginBottom: 20, display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
        <div>
          <div style={{ fontSize: 10, textTransform: "uppercase", letterSpacing: 3, color: "#666" }}>Copos Prime</div>
          <h1 style={{ fontSize: 28, fontWeight: 900, margin: "4px 0 0" }}>Relatório de Estoque</h1>
        </div>
        <div style={{ fontFamily: "IBM Plex Mono, monospace", fontSize: 11, textAlign: "right" }}>
          Gerado em<br />
          <strong>{now}</strong>
        </div>
      </div>

      {report.groups.map((g) => (
        <div key={g.type} style={{ marginBottom: 24 }}>
          <h2 style={{ fontSize: 16, fontWeight: 900, marginBottom: 6, background: "#000", color: "#fff", padding: "6px 10px" }}>
            {g.type_label} · {g.type}
          </h2>
          <table>
            <thead><tr><th>Cor</th><th style={{ width: 120, textAlign: "right" }}>Quantidade</th></tr></thead>
            <tbody>
              {g.colors.map((c) => (
                <tr key={c.color}>
                  <td>{c.color}</td>
                  <td style={{ textAlign: "right", fontFamily: "monospace", fontWeight: 600 }}>{c.stock.toLocaleString("pt-BR")}</td>
                </tr>
              ))}
              <tr className="total-row">
                <td>TOTAL {g.type_label}</td>
                <td style={{ textAlign: "right", fontFamily: "monospace" }}>{g.total.toLocaleString("pt-BR")}</td>
              </tr>
            </tbody>
          </table>
        </div>
      ))}

      <div style={{ marginTop: 30, borderTop: "3px solid #000", paddingTop: 15 }}>
        <table>
          <tbody>
            <tr>
              <td style={{ fontWeight: 900, fontSize: 14 }}>TOTAL GERAL (todos os tipos)</td>
              <td style={{ textAlign: "right", fontFamily: "monospace", fontWeight: 900, fontSize: 16, width: 160 }}>
                {report.grand_total.toLocaleString("pt-BR")}
              </td>
            </tr>
            <tr>
              <td style={{ fontWeight: 900, fontSize: 14, color: "#002FA7" }}>TOTAL POP + TWS (combinado)</td>
              <td style={{ textAlign: "right", fontFamily: "monospace", fontWeight: 900, fontSize: 16, color: "#002FA7" }}>
                {report.combined_pop_tws.toLocaleString("pt-BR")}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="no-print" style={{ marginTop: 30, textAlign: "center" }}>
        <button onClick={() => window.print()} style={{ padding: "10px 30px", fontWeight: 700, cursor: "pointer" }}>Imprimir</button>
        <button onClick={() => window.close()} style={{ padding: "10px 30px", marginLeft: 10, cursor: "pointer" }}>Fechar</button>
      </div>
    </div>
  );
}
